<template>
    <div>
        <div v-if="dataFetch" class="d-block pt-5">
            <div class="row justify-content-center">
                <p>Loading...</p>
            </div>
        </div>
        
        <div v-if="!dataFetch" class="d-block pt-5">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <div class="d-block h2 font-bold mb-5">
                        <div class="row">
                            <div class="col">
                                <i class="fa-solid fa-caret-right me-3 text-neon"></i> Resume Peluang Pilihan dan Pilihan Alternatif 
                            </div>
                            <div class="col-auto" v-if="(!dataFetchAltMajor && !dataFetch && !dataFetchAltGroupSubject)">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white btn-s-1" v-on:click="printRationalization" :disabled="fetch_download">
                                        <div class="btn-s-1-inner">
                                            <i v-if="!fetch_download" class="fa-solid fa-print me-3"></i>
                                            <i v-if="fetch_download" class="fa-solid fa-spin fa-spinner me-3"></i>
                                            {{ fetch_download ? 'Harap tunggu ...' : 'Cetak Resume' }} </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-block">
                        <div class="card overflow-hidden">
                            <div class="card-header">
                                <div class="d-block h3 m-0 text-pink">Sesuai Pilihan Kamu</div>
                            </div>
                            <table class="table table-sm-th table-sm-td table-sm table-hover mb-1">
                                <thead>
                                    <tr>
                                        <th class="ps-4">Jurusan</th>
                                        <th class="text-center">Min Nilai Rerata Rapor</th>
                                        <th class="text-center">Min Nilai Prasyarat</th>
                                        <th class="text-center">Nilai Rerata Rapor Saya</th>
                                        <th class="text-center">Nilai Prasyarat Saya</th>
                                        <th class="text-center">Index Nilai</th>
                                        <th class="text-center">Index Pendukung</th>
                                        <th class="text-center">Index Total</th>
                                        <th class="pe-4"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in dataEvaluation" :key="index">
                                        <td class="ps-4 font-bold m-0">
                                            {{ item.university_name }} - {{ item.major_fullname }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_subject }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_prerequisite }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_score }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_support }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.opportunity }}%
                                        </td>
                                        <td class="pe-4">
                                            <button type="button" v-on:click="goDetail(item.id, $parent.dataRationalization.code)" class="btn btn-white btn-sm">Detail</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="d-block">
                        <div class="card overflow-hidden">
                            <div class="card-header">
                                <div class="d-block h3 m-0 text-pink">Alternatif Pilihan Sesuai Minat Jurusan</div>
                            </div>
                            <table class="table table-sm-th table-sm-td table-sm table-hover mb-1">
                                <thead>
                                    <tr>
                                        <th class="ps-4">Jurusan</th>
                                        <th class="text-center">Min Nilai Rerata Rapor</th>
                                        <th class="text-center">Min Nilai Prasyarat</th>
                                        <th class="text-center">Nilai Rerata Rapor Saya</th>
                                        <th class="text-center">Nilai Prasyarat Saya</th>
                                        <th class="text-center">Index Nilai</th>
                                        <th class="text-center">Index Pendukung</th>
                                        <th class="text-center">Index Total</th>
                                        <th class="pe-4"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in dataAltMajor.alt_one" :key="index">
                                        <td class="ps-4 font-bold m-0">
                                            {{ item.university_name }} - {{ item.major_fullname }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_subject }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_prerequisite }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_score }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_support }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.opportunity }}%
                                        </td>
                                        <td class="pe-4">
                                            <button type="button" v-on:click="goDetail(item.id, $parent.dataRationalization.code, 'major')" class="btn btn-white btn-sm">Detail</button>
                                        </td>
                                    </tr>
                                    <tr v-for="(item, index) in dataAltMajor.alt_two" :key="index">
                                        <td class="ps-4 font-bold m-0">
                                            {{ item.university_name }} - {{ item.major_fullname }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_subject }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_prerequisite }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_score }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_support }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.opportunity }}%
                                        </td>
                                        <td class="pe-4">
                                            <button type="button" v-on:click="goDetail(item.id, $parent.dataRationalization.code, 'major')" class="btn btn-white btn-sm">Detail</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="d-block">
                        <div class="card overflow-hidden">
                            <div class="card-header">
                                <div class="d-block h3 m-0 text-pink">Alternatif Pilihan Sesuai Minat Rumpun</div>
                            </div>
                            <table class="table table-sm-th table-sm-td table-sm table-hover mb-1">
                                <thead>
                                    <tr>
                                        <th class="ps-4">Jurusan</th>
                                        <th class="text-center">Min Nilai Rerata Rapor</th>
                                        <th class="text-center">Min Nilai Prasyarat</th>
                                        <th class="text-center">Nilai Rerata Rapor Saya</th>
                                        <th class="text-center">Nilai Prasyarat Saya</th>
                                        <th class="text-center">Index Nilai</th>
                                        <th class="text-center">Index Pendukung</th>
                                        <th class="text-center">Index Total</th>
                                        <th class="pe-4"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in dataAltGroupSubject.alt_one" :key="index">
                                        <td class="ps-4 font-bold m-0">
                                            {{ item.university_name }} - {{ item.major_fullname }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_subject }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_prerequisite }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_score }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_support }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.opportunity }}%
                                        </td>
                                        <td class="pe-4">
                                            <button type="button" v-on:click="goDetail(item.id, $parent.dataRationalization.code, 'group_subject')" class="btn btn-white btn-sm">Detail</button>
                                        </td>
                                    </tr>
                                    <tr v-for="(item, index) in dataAltGroupSubject.alt_two" :key="index">
                                        <td class="ps-4 font-bold m-0">
                                            {{ item.university_name }} - {{ item.major_fullname }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.passing_grade }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_subject }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.avg_score_prerequisite }}
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_score }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.index_support }}%
                                        </td>
                                        <td class="text-center display-tektur h2 m-0">
                                            {{ item.opportunity }}%
                                        </td>
                                        <td class="pe-4">
                                            <button type="button" v-on:click="goDetail(item.id, $parent.dataRationalization.code, 'group_subject')" class="btn btn-white btn-sm">Detail</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="true"
                    :preview-modal="false"
                    :filename="'Resume Rasionalisasi'"
                    :paginate-elements-by-height="1100"
                    :pdf-quality="2"
                    pdf-format="a4"
                    pdf-orientation="landscape"
                    pdf-content-width="800px"
                    :manual-pagination="false"

                    @progress="onProgress($event)"
                    @hasDownloaded="hasDownloaded($event)"
                    ref="html2Pdf"
                    >

                    <EvaluationToPrint slot="pdf-content" :dataEvaluation="dataEvaluation" :dataAltMajor="dataAltMajor" :dataAltGroupSubject="dataAltGroupSubject" :dataUsers="$parent.dataRationalization.users"/> 
                </vue-html2pdf>
            </div>
        </div>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import EvaluationToPrint from "../../../components/print/evaluation.vue";

export default {
    name: 'RationalizationFormAchievement',
    data() {
        return {
            dataFetch               : false,
            dataFetchAltMajor       : false,
            dataFetchAltGroupSubject   : false,
            dataEvaluation          : [],
            dataAltMajor            : [],
            dataAltGroupSubject     : [],
            fetch_download          : false
        }
    },
    components: {
      VueHtml2pdf,
      EvaluationToPrint
    },
    created() {
        this.getEvaluation();
        this.getEvaluationAltMajor();
        this.getEvaluationAltGroupSubject();
    },
    methods: {
        getEvaluation: function() {
            this.dataFetch      = true;
            this.dataEvaluation = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation';
            this.$http.get(uri,{
                params : {
                    code    : this.$parent.dataRationalization.code
                }
            }).then(res => {
                this.dataFetch      = false;
                if(res.data.status) {
                    this.dataEvaluation    = res.data.data.evaluation;
                }
             });
        },
        getEvaluationAltMajor: function() {
            this.dataFetchAltMajor      = true;
            this.dataAltMajor           = [];

            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alternative';
            this.$http.get(uri,{
                params : {
                    code    : this.$parent.dataRationalization.code,
                    type    : 'major',
                    university_one    : this.$parent.dataRationalization.university_one,
                    major_one         : this.$parent.dataRationalization.major_one,
                    university_two    : this.$parent.dataRationalization.university_two,    
                    major_two         : this.$parent.dataRationalization.major_two,
                }
            }).then(res => {
                this.dataFetchAltMajor      = false;
                if(res.data.status) {
                    this.dataAltMajor    = res.data.data;
                }
             });
        },
        getEvaluationAltGroupSubject: function() {
            this.dataFetchAltGroupSubject      = true;
            this.dataAltGroupSubject           = [];

            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alternative';
            this.$http.get(uri,{
                params : {
                    code    : this.$parent.dataRationalization.code,
                    type    : 'group_subject',
                    university_one    : this.$parent.dataRationalization.university_one,
                    major_one         : this.$parent.dataRationalization.major_one,
                    university_two    : this.$parent.dataRationalization.university_two,    
                    major_two         : this.$parent.dataRationalization.major_two,
                }
            }).then(res => {
                this.dataFetchAltGroupSubject      = false;
                if(res.data.status) {
                    this.dataAltGroupSubject    = res.data.data;
                }
             });
        },
        goDetail: function(id, code, type="") {
            this.$router.push({
                name : 'rationalization_evaluation',
                params: { id: id, code: code },
                query : {
                    type : type
                }
            });
        },
        onProgress(event) {
            this.fetch_download = true;
            if(event >= 100) {
                this.fetch_download = false;
            }                
        },
        hasDownloaded(event) {
            console.log(`Processed: ${event} / 100`);
        },
        hasGenerated() {
            alert("PDF generated successfully!");
        },
        printRationalization() {
            this.$refs.html2Pdf.generatePdf();                
        }
    }
}
</script>